import type { TargetEntityResponseItem } from '~/api/sylvanus/typedefs.autogen';

import { EntityType } from '~/enums/EntityType';

import { getPromptModelResults } from './getPromptModelResults';

const PAGE_SIZE = 100;
const MAX_PAGES = 50;

export const getPublishedFieldPromptModelTargetEntities = async (): Promise<
  TargetEntityResponseItem[]
> => {
  const items: TargetEntityResponseItem[] = [];
  let pageIndex = 1;
  let totalCount = Number.POSITIVE_INFINITY;

  while ((pageIndex - 1) * PAGE_SIZE < totalCount && pageIndex <= MAX_PAGES) {
    const response = await getPromptModelResults({
      pageIndex,
      pageSize: PAGE_SIZE,
      status: 'published',
    });

    totalCount = response.totalCount;

    items.push(
      ...response.results
        .filter((model) => model.targetEntity.type === EntityType.Field)
        .map((model) => ({
          prompt_model_id: model.id,
          target_entity: {
            id: String(model.targetEntity.id),
            type: 'field' as const,
          },
        })),
    );

    pageIndex += 1;
  }

  return items;
};
